import React from 'react';
import { numberToPercent, AspectType } from '@fuxi/react-img-editor';

import MyIcon from '@/components/MyIcon';

import styles from './index.module.css';

interface SideToolbarProp {
  aspectMode: AspectType;
  onZoom: (direction: number) => void;
  scale: number;
  onAspectChange: (aspectMode: AspectType) => void;
  style?: React.CSSProperties;
}

const ZoomToolbar: React.FC<SideToolbarProp> = ({ aspectMode, onAspectChange, onZoom, scale, style }) => {
  return (
    <div className={styles['zoom-toolbar']} style={style}>
      {aspectMode === 'aspect-fill' && (
        <span
          key="fill-screen"
          className={styles['zoom-toolbar-icon']}
          onClick={() => onAspectChange(AspectType.aspectFit)}
          title="适应画布">
          <MyIcon icon="frame-151" size="24px"></MyIcon>
        </span>
      )}
      {aspectMode === 'aspect-fit' && (
        <span
          key="aspect-1-1"
          className={styles['zoom-toolbar-icon']}
          onClick={() => onAspectChange(AspectType.aspectFill)}
          title="原始比例">
          <MyIcon icon="1_1_eKznvi" size="24px" />
        </span>
      )}
      <span key="icon-zoom-in" className={styles['zoom-toolbar-icon']} onClick={() => onZoom(1)} title="放大">
        <MyIcon icon="zoom-in" size="24px" />
      </span>
      <span className={styles['zoom-toolbar-text']}>{numberToPercent(scale)}</span>
      <span key="icon-zoom-out" className={styles['zoom-toolbar-icon']} onClick={() => onZoom(-1)} title="缩小">
        <MyIcon icon="zoom-out" size="24px" />
      </span>
    </div>
  );
};
export default React.memo(ZoomToolbar);
